export default {
    deletedBehavior_deletedMetric: 'Eliminar Métrica',
    deletedBehavior_deletedMetric_success: 'Métrica Eliminada Exitosamente',
    deletedBehavior_metricMessage: '¿Estás seguro de que deseas eliminar esta métrica?',
    deletedBehavior_metricsMessage: '¿Estás seguro de que deseas eliminar las métricas seleccionadas?',
    deletedBehavior_allMetricsMessage: '¿Estás seguro de que deseas eliminar todas las métricas seleccionadas?',
}
